import api from "./documentApi";

export function extractSettlmentData(files: File[]) {
  return api.uploadFiles(
    files.map((file) => {
      return {
        fileName: file.name,
        data: file,
      };
    })
  );
}
